$(document).ready(function () {
  //alert("testing");
    function hybridSizesNew(val){
   console.log(val);
  console.log($(".cstm_check.swatch.custom_size-jtpl").find("input[value='"+val+"']"));
  //$(".cstm_check [data-option-index='2']").find(".swatch-element input[type='radio']").removeAttr("checked","checked");
//  $(".cstm_check [data-option-index='2']").find(".swatch-element input[value='"+val+"']").attr("checked","checked");
  $(".cstm_check.swatch.custom_size-jtpl").find("input[value='"+val+"']").parents(".swatch-element").trigger("click");
  $(".cstm_check.swatch.custom_size-jtpl").find("input[value='"+val+"']").parents(".swatch-element").find("label").trigger("click");
 var band_size = $.trim($(".csmt_band_jtpl #custm_band_size_option").val());
 var cup_size = $.trim($(".csmt_cup_jtpl #custm_cup_size_option").val());
      getBandHybridSizes(band_size,val,cup_size);   
       
  }

  var tableData = {
  30: {
    "US C - UK C": "S",
    "US D - UK D": "S",
    "US DD - UK DD": "S",
    "US DDD - UK E": "S Plus",
    "US G - UK F": "S Plus",
    "US H - UK FF": "S Plus",
  },
  32: {
    "US C - UK C": "S",
    "US D - UK D": "S",
    "US DD - UK DD": "S Plus",
    "US DDD - UK E": "S Plus",
    "US G - UK F": "M",
    "US H - UK FF": "M Plus",
    "US I - UK G": "M Plus",
    "US J - UK GG": "M Plus",
    "US K - UK H": "L Plus",
  },
  34: {
    "US C - UK C": "S",
    "US D - UK D": "M",
    "US DD - UK DD": "M",
    "US DDD - UK E": "M",
    "US G - UK F": "M Plus",
    "US H - UK FF": "M Plus",
    "US I - UK G": "L",
    "US J - UK GG": "L Plus",
    "US K - UK H": "XL Plus",
  },
  36: {
    "US C - UK C": "M",
    "US D - UK D": "M",
    "US DD - UK DD": "L",
    "US DDD - UK E": "L",
    "US G - UK F": "L",
    "US H - UK FF": "L Plus",
    "US I - UK G": "XL",
    "US J - UK GG": "XL Plus",
    "US K - UK H": "2X Plus",
  },
  38: {
    "US D - UK D": "L",
    "US DD - UK DD": "L",
    "US DDD - UK E": "L",
    "US G - UK F": "L Plus",
    "US H - UK FF": "XL Plus",
    "US I - UK G": "2X",
    "US J - UK GG": "2X Plus",
    "US K - UK H": "2X Plus",
  },
  40: {
    "US D - UK D": "XL",
    "US DD - UK DD": "XL",
    "US DDD - UK E": "XL",
    "US G - UK F": "XL Plus",
    "US H - UK FF": "2X",
    "US I - UK G": "3X",
    "US J - UK GG": "3X Plus",
    "US K - UK H": "3X Plus",
  },
  42: {
    "US D - UK D": "2X",
    "US DD - UK DD": "2X",
    "US DDD - UK E": "2X",
    "US G - UK F": "2X",
    "US H - UK FF": "3X",
    "US I - UK G": "3X Plus",
    "US J - UK GG": "3X Plus",
  },
  44: {
    "US DD - UK DD": "3X",
    "US DDD - UK E": "3X",
    "US G - UK F": "3X",
    "US H - UK FF": "3X Plus",
    "US I - UK G": "3X Plus",
  },
};

//   var tableData = {
//     30: {
//       "US C - UK C": "S",
//       "US D - UK D": "S",
//       "US DD - UK DD": "S Plus",
//       "US DDD - UK E": "S Plus",
//       "US G - UK F": "S Plus",
//       "US H - UK FF": "S Plus",
//       "US I - UK G": "M Plus",
//       "US J - UK GG": "M Plus",
//       "US K - UK H": "M Plus",
//     },
//     32: {
//       "US C - UK C": "S",
//       "US D - UK D": "S",
//       "US DD - UK DD": "S Plus",
//       "US DDD - UK E": "M",
//       "US G - UK F": "M",
//       "US H - UK FF": "M Plus",
//       "US I - UK G": "M Plus",
//       "US J - UK GG": "M Plus",
//       "US K - UK H": "L Plus",
//       "US L - UK HH": "XL Plus",
//     },
//     34: {
//       "US C - UK C": "S",
//       "US D - UK D": "S",
//       "US DD - UK DD": "S Plus",
//       "US DDD - UK E": "M",
//       "US G - UK F": "M",
//       "US H - UK FF": "M Plus",
//       "US I - UK G": "L",
//       "US J - UK GG": "L Plus",
//       "US K - UK H": "XL Plus",
//       "US L - UK HH": "2XL Plus",
//     },
//     36: {
//       "US D - UK D": "M",
//       "US DD - UK DD": "M",
//       "US DDD - UK E": "M",
//       "US G - UK F": "L",
//       "US H - UK FF": "L",
//       "US I - UK G": "XL",
//       "US J - UK GG": "XL Plus",
//       "US K - UK H": "2XL Plus",
//       "US L - UK HH": "3XL Plus",
//     },
//     38: {
//       "US DD - UK DD": "L",
//       "US DDD - UK E": "L",
//       "US G - UK F": "L",
//       "US H - UK FF": "XL",
//       "US I - UK G": "2XL",
//       "US J - UK GG": "2XL Plus",
//       "US K - UK H": "3XL Plus",
//       "US L - UK HH": "3XL Plus",
//     },
//     40: {
//       "US DD - UK DD": "XL",
//       "US DDD - UK E": "XL",
//       "US G - UK F": "XL",
//       "US H - UK FF": "XL Plus",
//       "US I - UK G": "2XL",
//       "US J - UK GG": "3XL Plus",
//       "US K - UK H": "3XL Plus",
//     },
//     42: {
//       "US DDD - UK E": "2XL",
//       "US G - UK F": "2XL",
//       "US H - UK FF": "2XL",
//       "US I - UK G": "3XL Plus",
//       "US J - UK GG": "3XL Plus",
//     },
// };

function getBandBasedCupSize(band_size) {
    var calcData = tableData[band_size];  // Get the mapping for the selected band size
    if (!calcData) return;  // If there's no data for the band size, exit early
    
    $(".csmt_cup_jtpl #custm_cup_size_option option").each(function() {
        var $this = $(this);
        var value = $.trim($this.attr("value"));  // Get the value attribute of the option
       // console.log(band_size + "====" + value);

        // Check if the value exists in tableData for this band size and if it's valid
        if (calcData[value] !== undefined && calcData[value] !== null && calcData[value] !== "") {
            $this.removeClass("hidden-size-jtpl");  // Show the option if valid
        } else {
            $this.addClass("hidden-size-jtpl");  // Hide the option if invalid
        }
    });
}

  
  
  //  function getBandBasedCupSize(band_size){
  //   var calcData = tableData[band_size];
  //    var html = '';
  //    // $(".csmt_cup_jtpl #custm_cup_size_option option").addClass("hidden-size-jtpl");
  //    $(".csmt_cup_jtpl #custm_cup_size_option option").each(function(){
  //      var $this = $(this);
  //      var value = $.trim($(this).attr("value"));
  //      console.log(band_size+"===="+value);
  //      console.log(tableData[band_size][value]);
  //      if(tableData[band_size][value] != undefined && tableData[band_size][value] != null && tableData[band_size][value] != ""){
  //          $this.removeClass("hidden-size-jtpl");
  //      }
       
  //    });
     
  // }
  // function both_dropdownoption (){
  //     $('#custom_size_chart').change(function() {
  //       $('#custom_size_chart').find("option").removeClass("activetab");
  //      var selected_option =  $(this).find('option.activetab').addClass('activetab');
  //       console.log('selected_option'+selected_option);
  //     var band_option = $('#custm_band_size_option').prop('selectedIndex', 0); 
  //       console.log("band_option"+band_option);
  //    var cup_option = $('#custm_cup_size_option').prop('selectedIndex', 0); 
  //       console.log("cup_option"+cup_option);
  //         $(".custom_class_size_chart").hide(); Default action prevented
   
  //    });
  // }
 
  //  function getBandHybridSizes(band_size,val,cup_size){
  //    var calcData = tableData[band_size];
  //    console.log("calcData"+calcData);
  //    var html = '';
  //    var usSizesHTML = '';
  //    var uKSizesHTML = '';
  //      $(".hybrid-sizes-jtpl").html("");
  //     $.each(calcData, function(keyName, keyValue) {
  //       if(keyValue.indexOf(val) > -1){ 
  //         if(keyValue == val){
  //         console.log("cup_size : "+cup_size + "keyName: "+keyName);
  //         console.log(" cup size console : "+calcData + "value data "+val );
  //         if(cup_size != keyName){
  //           if(html != ""){
  //             html += ", ";                
  //           }
  //            if(usSizesHTML != ""){
  //             usSizesHTML += ", ";                
  //           } 
            
  //            if(uKSizesHTML != ""){
  //             uKSizesHTML += ", ";                
  //           }
  //           var retArr = keyName.split("-");
  //           usSizesHTML += band_size+""+$.trim(retArr[0].replace("US","").replace("   ","").replace(" ",""));
  //           uKSizesHTML += band_size+""+$.trim(retArr[1].replace("UK","").replace("   ","").replace(" ",""));
  //           html +=band_size+" "+keyName;
  //           console.log("testloop...."+html);
  //         }
  //       //console.log("cup_size == " cup_size);
  //         }
  //       }
  //    if(html != ""){
  //       $(".hybrid-sizes-jtpl").html("<table class='size-chart-jtpl'><tr><td rowspan='2'><b>"+val+" Fits </b></td><td><b>US</b></td><td>"+usSizesHTML+"</td></tr><tr><td><b>UK</b></td><td>"+uKSizesHTML+"</td></tr></table>");
  //     $(".custom_class_size_chart").show();  
  //     console.log("sizes=="+keyName + ': ' + keyValue);
  //    }else{
  //      $(".custom_class_size_chart").hide();  
  //    }
       
  //   }); 
     
  // }
  
function getBandHybridSizes(band_size, val, cup_size) {
    var html = '';
    var usSizesHTML = '';
    var uKSizesHTML = '';
    $(".hybrid-sizes-jtpl").html("");
    $.each(tableData, function(band, calcData) {
        $.each(calcData, function(keyName, keyValue) {
          
            if (keyValue.indexOf(val) > -1) {
                if(keyValue == val){
                if (html !== "") {
                    html += ", ";
                }
                if (usSizesHTML !== "") {
                    usSizesHTML += ", ";
                }
                if (uKSizesHTML !== "") {
                    uKSizesHTML += ", ";
                }
                var retArr = keyName.split("-");
                var usSize = $.trim(retArr[0].replace("US", "").replace(" ", ""));
                  //console.log("usSize==="+usSize);
                var ukSize = $.trim(retArr[1].replace("UK", "").replace(" ", ""));
                 // console.log("ukSize==="+ukSize);
                
                usSizesHTML += band + "" + usSize;  
                uKSizesHTML += band + "" + ukSize;  
                html += band + " " + keyName;  
            }
            }
        });
    });

  
    if (html !== "") {
        $(".hybrid-sizes-jtpl").html("<table class='size-chart-jtpl'><tr><td rowspan='2'><b>" + val + " Fits </b></td><td><b>US</b></td><td>" + usSizesHTML + "</td></tr><tr><td><b>UK</b></td><td>" + uKSizesHTML + "</td></tr></table>");
        $(".custom_class_size_chart").show(); 
        console.log("sizes: " + html);
    } else {
        $(".custom_class_size_chart").hide(); 
    }
}

   
  // Example of accessing data
 // let value = tableData[36]["US H - UK FF"]; // Adjust key as per your use
 // alert(value); // Output: L

  // Example: Accessing data
   
  var first_dropDown = "";
  var second_dropDown = "";
    $("body").on("change",".csmt_band_jtpl #custm_band_size_option",function (e) {
    e.preventDefault();
    var first_dropDown = $.trim($(this).val());
    if(first_dropDown == ""){
    return false;
    }
        getBandBasedCupSize(first_dropDown);
    var second_dropDown = $.trim($(".csmt_cup_jtpl #custm_cup_size_option").val());
      console.log("second_dropDown =="+second_dropDown);
    var value_chart = tableData[first_dropDown][second_dropDown];
      
    $(".size-filter-jtpl option").removeAttr("selected");
    $(".size-filter-jtpl option").each(function () {
      var third_size_option = $(this).attr("value");
    
      if (third_size_option == value_chart) {
        $(this).attr("selected", "selected");
        hybridSizesNew(third_size_option);
      
      }
  $('#custm_band_size_option').change(function(e) {
          e.preventDefault();
    
  $('#custm_cup_size_option').val(''); // Reset Cup dropdown to default
  
  var third_option_val = $('.size-filter-jtpl.custom_size_chart option').eq(0).text().trim(); // Get the text content
  console.log("third_option_val: " + third_option_val); // Log the value
  
  // Check if third option value is 'Size'
  if (third_option_val == 'Size') {
    // Prevent the default behavior if the condition is met
    e.preventDefault();  // Prevent any default action from taking place
    // Optionally, you can log a message to confirm preventDefault was triggered
    $('.custom_class_size_chart').hide(); 
    //console.log('Default action prevented');
  }
});

    });
    }
    );
  $("body").on("change", ".csmt_cup_jtpl #custm_cup_size_option", function (e) {
     e.preventDefault();
    var second_dropDown = $.trim($(this).val());
    if(second_dropDown == ""){
        return false;
      }
    
    var first_dropDown = $.trim($(".csmt_band_jtpl #custm_band_size_option").val());
    var value_chart = tableData[first_dropDown][second_dropDown];
    console.log("value_chart"+value_chart);
    
    $(".size-filter-jtpl option").removeAttr("selected");
    $(".size-filter-jtpl option").each(function () {
      var third_size_option = $(this).attr("value");
      if (third_size_option == value_chart) {
        $(this).attr("selected", "selected");
        hybridSizesNew(third_size_option);
      }
    });
  });
  
  var currentUrl = window.location.href;
  $("body").on("click",".product-color-options .swatches_color .swatch_color", function () {
      $(".product-color-options .swatches_color .swatch_color.selected").removeClass("selected");
      var swatch_val = $(this).addClass("selected");
      $(this).parents(".main_content_color").find(".variants-option-label").text($(this).find("input").val());

      // Get the parameter and value from data attributes
      var param = $(this).find("input").val().toLowerCase();
       var newcurrentUrl = currentUrl.split("?");
      var size__chart = $(".color_varients #custom_size_chart").val();
         $(".size-filter-jtpl option").removeAttr("selected");
      $(".size-filter-jtpl option").each(function () {
        var valText = $(this).attr("value");
        if (size__chart == valText) {
          var size_chart_id = $(this).attr("chart_size_id");
          var newUrl;
          if (currentUrl.indexOf("?") > -1) {
            // URL has existing query parameters, append to it
            newUrl =
              newcurrentUrl[0] + "?" + "variant=" + size_chart_id + "&color=" + param;
          } else {
            // URL has no query parameters, start a new one
            newUrl =
              newcurrentUrl[0] + "?" + "variant=" +size_chart_id +"&color=" + param;
          }
          window.history.pushState({ path: newUrl }, "", newUrl);
        }
      });
    }
  );


  
  //  let value = tableData["36"]["US DDD - UK E"]; // This will return "L"
  // alert(value);
});

// $(document).ready(function() {
//   // Function to check if Band or Cup has a blank value and update Size accordingly
//   function checkAndSetSize() {
//     console.log("this is working");
//     var bandValue = $('#custm_band_size_option').val();  // Get Band dropdown value
//     var cupValue = $('#custm_cup_size_option').val();    // Get Cup dropdown value
    
//     // If either Band or Cup value is empty, set the Size dropdown to default (S)
//     if (bandValue === "" || cupValue === "") {
//       $('#custom_size_chart').val('S'); // Set size dropdown to default (S)
//     }
//   }
//  $("body").on("change","#custm_band_size_option, #custm_cup_size_option",function (e) {
//     e.preventDefault();
//   // Trigger check and update Size when Band or Cup dropdown changes
//     checkAndSetSize();
//   });

//   // Initial check on page load in case the Band or Cup value is already set
//   checkAndSetSize();
// });


document.addEventListener("DOMContentLoaded", function() {
  // Use setTimeout to wait 1 second before resetting the values
  setTimeout(function() {
    // Reset the size and cup dropdowns
    document.getElementById("custm_band_size_option").value = "";
    document.getElementById("custm_cup_size_option").value = "";
    document.getElementById("custom_size_chart").value = "";

    // Uncheck all radio buttons
    let sizeRadioButtons = document.querySelectorAll('input[name="size"]');
    sizeRadioButtons.forEach(function(radio) {
      radio.checked = false;
    });

    // Hide any custom size charts or other elements
    document.querySelector('.custom_class_size_chart').style.display = "none";
  }, 1000); // 1-second delay (1000 milliseconds)
});
